import "./App.css";
import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home";
import About from "./About";
import EventPage from "./EventPage";
import BookingConfirmation from "./BookingConfirmation";
import Admin from "./Admin";
import { Analytics } from "@vercel/analytics/react";

function App() {
  return (
    <ChakraProvider>
      <BrowserRouter>
        <Analytics />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/booking/confirmation" element={<BookingConfirmation />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/:slug" element={<EventPage />} />
        </Routes>
      </BrowserRouter>
    </ChakraProvider>
  );
}

export default App;
